<template>
  <div class="d-flex flex-column align-items-center w-full"
    :class="{'invisible' : invisible }">
    <div class="d-flex align-items-center justify-content-center text-center rounded green-block green-text">
      <span>{{ label }}</span>
    </div>
    <span class="mt-1 green-text"><small><strong>{{caption}}</strong></small></span>
  </div>
</template>

<script>
export default {
  props: {
    label: String, caption: String, invisible: {type: Boolean, default: false}
  }
}
</script>

<style lang="scss">
.green-block {
  background-color: #cce6d9;
  height: 2em;
  width: 2em;
  font-size: 1.5em;
}

.green-text {
  text-transform: uppercase;
  color: $saka-green;
}
</style>
